export const addressSectionStyles = {
	root: {
		display: 'flex',
		flexDirection: 'row',
		gap: 1,
		minWidth: 0
	},

	fieldWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1,
		width: '100%',
		minWidth: 0
	},

	cardsContainer: {
		border: '1px solid var(--mui-palette-divider)',
		borderRadius: 1,
		minWidth: 0
	},

	addNewCardButton: {
		display: 'flex',
		justifyContent: 'flex-start',
		width: 'max-content'
	},

	label: {
		maxWidth: '200px',
		minWidth: '200px',
		color: 'text.fadedPrimary',
		fontWeight: 700,
		fontSize: '1rem'
	}
};
